import React, {useCallback} from 'react';
import './LeaveEmpty.css';
import {Button} from "@chakra-ui/react";
import {WarningIcon} from "@chakra-ui/icons";

const LeaveEmpty = (props) => {
    return (
        <Button leftIcon={<WarningIcon />} className={'leave_btn'} {...props}>Lascia vuoto</Button>
    );
};

export default LeaveEmpty;
